import { render, staticRenderFns } from "./BhUserCard.vue?vue&type=template&id=128cd912&"
import script from "./BhUserCard.vue?vue&type=script&lang=js&"
export * from "./BhUserCard.vue?vue&type=script&lang=js&"
import style0 from "./BhUserCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports